'use client';

export const LoadingSpinner = ({ className, ...props }: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<svg
			width="32"
			height="32"
			viewBox="0 0 32 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
			{...props}
		>
			<path
				d="M29.9875 8.23149C31.7114 11.3354 32.3539 14.9246 31.8138 18.4338C31.2737 21.943 29.5818 25.1728 27.0044 27.6148C24.427 30.0567 21.1105 31.572 17.5773 31.9221C14.0441 32.2721 10.4948 31.4369 7.4884 29.5482C4.48197 27.6594 2.18918 24.8242 0.971081 21.4892C-0.247017 18.1542 -0.321224 14.5088 0.760147 11.1269C1.84152 7.74509 4.01703 4.819 6.94411 2.80944C9.87119 0.799873 13.3835 -0.179009 16.9281 0.0269387L16.7578 2.95772C13.8636 2.78957 10.9957 3.58884 8.60571 5.22968C6.2157 6.87053 4.43936 9.25973 3.5564 12.021C2.67344 14.7824 2.73404 17.7589 3.72863 20.482C4.72323 23.2051 6.59533 25.5201 9.05014 27.0623C11.5049 28.6045 14.403 29.2864 17.2879 29.0006C20.1728 28.7148 22.8808 27.4776 24.9853 25.4837C27.0898 23.4898 28.4713 20.8525 28.9122 17.9872C29.3532 15.1219 28.8286 12.1913 27.421 9.65688L29.9875 8.23149Z"
				fill="currentColor"
			/>
		</svg>
	);
};
